import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';

// Shared by the "grab" flow (AvailableShiftsScreen) and the "reassign" flow
// (MyShiftsScreen) — both just need a worker name/contact/email and a
// submit handler; the two screens differ only in which mutation they wire
// up and what the dialog title/button say.
const WorkerAssignDialog = ({
  open,
  onClose,
  onSubmit,
  isSubmitting,
  shift,
  title,
  submitLabel,
  initialWorker,
}) => {
  const [workerName, setWorkerName] = useState('');
  const [workerContact, setWorkerContact] = useState('');
  const [workerEmail, setWorkerEmail] = useState('');

  useEffect(() => {
    if (open) {
      setWorkerName(initialWorker?.name || '');
      setWorkerContact(initialWorker?.contact || '');
      setWorkerEmail(initialWorker?.email || '');
    }
  }, [open, initialWorker]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ workerName, workerContact, workerEmail });
  };

  if (!shift) return null;

  const start = new Date(shift.startDateTime);
  const end = new Date(shift.endDateTime);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <Stack sx={{ px: 3, pb: 1 }} spacing={0.5}>
        <Typography variant="body2" color="text.secondary">
          {shift.wardDepartmentArea} — {shift.hospitalLocationId?.name || ''}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {start.toLocaleDateString()} {start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          {' – '}
          {end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </Typography>
      </Stack>

      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent sx={{ pt: 0 }}>
          <TextField
            label="Worker name"
            fullWidth
            required
            margin="dense"
            value={workerName}
            onChange={(e) => setWorkerName(e.target.value)}
            autoFocus
          />
          <TextField
            label="Worker contact number"
            fullWidth
            margin="dense"
            value={workerContact}
            onChange={(e) => setWorkerContact(e.target.value)}
          />
          <TextField
            label="Worker email"
            type="email"
            fullWidth
            margin="dense"
            value={workerEmail}
            onChange={(e) => setWorkerEmail(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={20} color="inherit" /> : submitLabel}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default WorkerAssignDialog;
